import MkuRadioGroup from '../radio/src/radio-group';

MkuRadioGroup.install = function (Vue) {
  Vue.component(MkuRadioGroup.name, MkuRadioGroup);
};

export default MkuRadioGroup;
